import { useMutation } from 'react-query';
import { setHealthProfileModuleOnboardingComplete } from '@leagueplatform/assessment-api';

export const useCompleteOnboarding = (moduleId: string) =>
  useMutation(() => setHealthProfileModuleOnboardingComplete(moduleId));
